import { Route, Routes } from 'react-router';
import { LoginPage, RequireAuth } from '../auth';
import { AdminPage } from '../features/admin';
import { InboxLayout } from '../layout/InboxLayout';
import { ConversationPage } from '../pages/ConversationPage';
import { NoConversationPage } from '../pages/NoConversationPage';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * Mapa de rotas. As conversas ficam em `/c/:conversationId` (e não em `/conversations`) para a
 * interface nunca colidir com as rotas da API, que o proxy repassa ao servidor sob `/api`.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        {/* Administração (usuários, WhatsApp e Bitrix): tela própria, fora da casca da caixa de entrada.
            Quem não é administrador vê "acesso negado" (a página confere o papel; a API também). */}
        <Route path="admin/*" element={<AdminPage />} />
        <Route element={<InboxLayout />}>
          <Route index element={<NoConversationPage />} />
          {/* Uma rota só, com filhas apenas para o roteador reconhecer os endereços: a página é a
              MESMA nos dois (não remonta ao alternar) e lê `detalhes` com useMatch para escolher
              qual coluna aparece em tela média/estreita. Subcaminhos desconhecidos caem no 404. */}
          <Route path="c/:conversationId" element={<ConversationPage />}>
            <Route index element={null} />
            <Route path="detalhes" element={null} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
